export const PUSH_TOXICITY_SCORE = "PUSH_TOXICITY_SCORE"
export const RESET_TOXICITY_SCORES = "RESET_TOXICITY_SCORES"
export const SET_STATEMENT = "SET_STATEMENT"
export const RESET_STATEMENT = "RESET_STATEMENT"
export const SET_MTURK_STATEMENT = "SET_MTURK_STATEMENT"
export const RESET_MTURK_STATEMENT = "RESET_MTURK_STATEMENT"
export const SET_CHECKIN_THOUGHT_LOADING = "SET_CHECKIN_THOUGHT_LOADING"